import { accordionDetailsClasses } from '@mui/material';
const MuiAccordion = {
  styleOverrides: {
    root: () => ({
      border: 0,
      boxShadow: 'none',
      [`.${accordionDetailsClasses.root}`]: {
        padding: 0
      },
      '&:before': {
        display: 'none'
      }
    })
  }
};
export default MuiAccordion;